module.exports = __webpack_public_path__ + "static/media/socialPiper-post-tablet-es.0772a910.png";